import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AttendanceReportsService } from '../../services/attendance-reports.service';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-edit-attendance-reports',
  templateUrl: './edit-attendance-reports.component.html',
  styleUrls: ['./edit-attendance-reports.component.scss']
})
export class EditAttendanceReportsComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;
  attendanceReportsId: string = '';
  formServiceInformation = new UntypedFormGroup({
    protocol: new UntypedFormControl('', [Validators.required]),
    status: new UntypedFormControl('', [Validators.required]),
    observation: new UntypedFormControl(''),
    externalProtocol: new UntypedFormControl('')
  });

  constructor(
    private readonly attendanceReportsService: AttendanceReportsService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly toastService: ToastService,
    private readonly router: Router,
  ) { }

  ngOnInit(): void {
    this.attendanceReportsId = this.activatedRoute.snapshot.paramMap.get('id')!;

    if (this.attendanceReportsId) {
      this.attendanceReportsService.getAttendanceReportById(this.attendanceReportsId).subscribe(response => {
        if (response.isSucceed) {
          this.formServiceInformation.get('protocol')?.setValue(response.data.protocolNumber);
          this.formServiceInformation.get('protocol')?.disable();
          this.formServiceInformation.get('status')?.setValue(response.data.status);
          this.formServiceInformation.get('observation')?.setValue(response.data.observation);
          this.formServiceInformation.get('externalProtocol')?.setValue(response.data.externalProtocol)
        }
      });
    }
  }

  public editAttendanceReports(): void {
    if (this.formServiceInformation.invalid) {
      this.toastService.toast('Preencha todos os campos obrigatórios antes de salvar.');
      this.formServiceInformation.markAllAsTouched();
      return;
    }

    const updateAttendanceReports = {
      ...this.formServiceInformation.value,
    };

    if (this.formServiceInformation) {
      this.attendanceReportsService.updateAttendanceReport(this.attendanceReportsId, updateAttendanceReports).subscribe(response => {
        if (response.isSucceed) {
          this.toastService.toast('Relatório de atendimento atualizado com sucesso.');
          this.router.navigateByUrl('/dash/relatorios');
        } else {
          this.toastService.toast('Erro ao atualizar o Relatório de atendimento.');
        }
      });
    }
  }
}
